import { FiltersTypes } from "@common/types/filters/general";
import { View } from "@common/types/views/views";
import { ColumnSettings } from "@design-system/ViewToolbar/ColumnSettings";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import {
    FilterTabs,
    FiltersChangeFn,
} from "@components/pageHeader/filters/lib";
import { applyCoaTemplateEntitySelectionViewConfig } from "./applyCoaTemplateEntitySelectionViewConfig";
import { defaultApplyCoaEntitySelectionView } from "./applyCoaTemplateEntitySelectionView.constants";

const defaultFilters: FiltersTypes = {};

// Client-level filters that match our columns and are backed by the clients
// page filter panels (which self-source their options). Legal type is omitted
// — the list is already pre-filtered to the template's legal type.
const availableFilters: FilterTabs[] = [
    FilterTabs.SERVICES,
    FilterTabs.TEAM_MEMBERS,
    FilterTabs.ENTITY_INDUSTRY,
    FilterTabs.ENTITY_BASIS,
];

interface Props {
    searchFilter: string | undefined;
    onSearchChange: (value: string | undefined) => void;
    filters: FiltersTypes;
    onFiltersChange: FiltersChangeFn;
    view: View;
    onViewChange: (view: View) => void;
}

export const ApplyCoaTemplateSelectEntitiesToolbar = ({
    searchFilter,
    onSearchChange,
    filters,
    onFiltersChange,
    view,
    onViewChange,
}: Props) => (
    <TablePageHeader
        isFullPage
        search={searchFilter}
        onSearchChange={(val) => onSearchChange(val || undefined)}
        filters={filters}
        onFiltersChange={onFiltersChange}
        availableFilters={availableFilters}
        defaultFilters={defaultFilters}
        defaultTab={FilterTabs.SERVICES}
        tabLabels={{ [FilterTabs.SERVICES]: "Services" }}
    >
        <ColumnSettings
            view={view}
            viewConfig={applyCoaTemplateEntitySelectionViewConfig}
            defaultView={defaultApplyCoaEntitySelectionView}
            onViewChange={onViewChange}
        />
    </TablePageHeader>
);
